import axios from "const/axios";
import { MAX_UPLOAD_FILE_SIZE_BYTES, MAX_UPLOAD_FILE_SIZE_LABEL } from "constants/fileUploadLimits";

export const formatFileSize = (bytes) => {
  if (!Number.isFinite(bytes)) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const uploadErrorMessage = (error) => {
  const status = Number(error?.response?.status ?? error?.request?.status);
  if (status === 413) return "File is too large, please reduce the file size.";
  return error?.response?.data?.errorMessage || error?.message || "Error uploading file";
};

export const uploadFileToStorage = async (file, { maxSize = MAX_UPLOAD_FILE_SIZE_BYTES } = {}) => {
  if (file?.size > maxSize) {
    throw new Error(
      `${file.name} is too large (${formatFileSize(
        file.size
      )}). Maximum allowed size is ${MAX_UPLOAD_FILE_SIZE_LABEL}.`
    );
  }

  const formData = new FormData();
  formData.append("file", file);
  const response = await axios.post("file/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  const url = response?.data?.url;
  if (!url) throw new Error("Upload did not return a file link");
  return url;
};
